"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var amber_1 = require("../../colors/amber");

var secondary = {
  light: amber_1["default"][100],
  main: amber_1["default"].A400,
  dark: amber_1["default"][500]
};
exports["default"] = secondary;